var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('ais-instant-search',{attrs:{"search-client":_vm.searchClient,"index-name":"ct_live_products"}},[_c('Main')],1),_c('vue-headful',{attrs:{"url":'https://cherrytree.co.nz/c2' + _vm.$route.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }